import { $http } from "@/plugins/api";

const mailHistory = () => {
  return {
    totalEmailsAnalyzed: 0,
    totalIncidents: 0,
  };
};
const state = mailHistory();

const getters = {
  totalEmailsAnalyzed: (state) => state.totalEmailsAnalyzed,
  totalIncidents: (state) => state.totalIncidents,
};

const actions = {
  async getTotalEmailsAnalyzed({ commit }, { organisationId, params }) {
    const filterParams = new URLSearchParams(params);

    const res = await $http.get(
      `${
        import.meta.env.VITE_API_CLIENT
      }/v3/pt/history/${organisationId}/messages/count?${filterParams.toString()}`,
    );

    commit("setTotalEmailsAnalyzed", res.data.count);
  },
  async getTotalIncidents({ commit }, { organisationId, params }) {
    const filterParams = new URLSearchParams(params);

    const res = await $http.get(
      `${
        import.meta.env.VITE_API_CLIENT
      }/v3/pt/history/${organisationId}/incidents/count?${filterParams.toString()}`,
    );

    commit("setTotalIncidents", res.data.count);
  },
};

const mutations = {
  setTotalEmailsAnalyzed: (state, count) => (state.totalEmailsAnalyzed = count),
  setTotalIncidents: (state, count) => (state.totalIncidents = count),
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
